export const filterObjectsByOwner = (results, ownerId = null):[] => {
    if (!ownerId) return results;

    return results.filter(result => (
        result.instance?.property?.companyId === ownerId || //Units
        result.instance?.id === ownerId || //Companies
        result.instance?.companyId === ownerId || //Properties
        result.instance?.unit?.property?.companyId === ownerId //Contracts
    ));
}